import { createContext, useContext } from 'react';
import { Cart } from '../api/types/vendor/carts-types';

export type OrdersCallback = (newOrders: Cart[], orders: Cart[]) => void;

// Define the shape of the notification context
type OrdersContextType = {
  registerCallback: (id: string, callback: OrdersCallback) => () => void;
};

const OrdersContext = createContext<OrdersContextType>({
  registerCallback: () => () => {},
});

// Hook to allow child components to access the notification context
const useOrders = () => {
  const context = useContext(OrdersContext);
  if (!context) {
    throw new Error(
      'useOrders must be used within a OrderNotificationProvider', // Ensure proper usage
    );
  }
  return context;
};

export { OrdersContext, useOrders };
